/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {ReactNode} from 'react';

export enum AppliedFilterBarFavoriteState {
  None = 'none',
  Saved = 'saved',
  Working = 'working'
}

export interface AppliedFilterBarItem {
  groupLabel?: string;
  icon?: ReactNode;
  id: string;
  /**
   * Shows the chip as a warning - the filter it stands for is not reflected
   * in what is shown, e.g. a History report kept on its previous results.
   */
  isWarning?: boolean;
  label: string;
  /**
   * Fires when the chip body is clicked. When omitted, falls back to
   * `onDelete` (this bar's own default) - a caller with a distinct click
   * interaction (e.g. Modular Search's click-to-edit) sets this
   * separately from `onDelete`.
   */
  onClick?: () => void;
  onDelete: () => void;
}

export interface AppliedFilterBarProps {
  /**
   * The id of an element that covers the bar's left side - the open filter
   * drawer - so the bar starts where it ends, never under it.
   */
  avoidElementId?: string;
  clearAllLabel?: string;
  clearAllMessage?: string;
  clearAllTitle?: string;
  count: number;
  favoriteState?: AppliedFilterBarFavoriteState;
  /**
   * When `true`, hides the count beside the label, leaving the label and
   * the favorite icon in place - e.g. Tracking, while its only chip is the
   * Timeline or History mode's, which the count does not include.
   */
  hideCount?: boolean;
  /**
   * When `true`, hides the "label + count" prefix group (and the
   * favorite icon slot alongside it). Tracking keeps its own label/count
   * shown by default.
   */
  hideLabel?: boolean;
  items: AppliedFilterBarItem[];
  isModularSearch?: boolean;
  onClearAll: () => void;
  /**
   * When `true`, Clear All fires `onClearAll` immediately, skipping the
   * confirmation dialog. Tracking keeps its own confirmation by default.
   */
  skipClearAllConfirmation?: boolean;
}
